import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
import ShowChartIcon from '@mui/icons-material/ShowChart'
export const NAV_LINKS = {
  SIGNIN: {
    to: '/signin',
    label: 'Connexion',
    displayMenu: false,
    icon: <></>,
  },
  HOME: {
    to: '/home',
    label: 'common:home',
    displayMenu: true,
    icon: <HomeOutlinedIcon />,
  },
  REPORT: {
    to: '/report',
    label: 'common:reports',
    displayMenu: true,
    icon: <ShowChartIcon />,
  },
  OSS_LICENSES: {
    to: '/oss-licenses',
    label: 'common:oss.licenses',
    displayMenu: false,
    icon: <></>,
  },
}

export const HOST = import.meta.env.VITE_HOST || 'http://localhost:4000'
export const CLIENT_ID = import.meta.env.VITE_CLIENT_ID
export const RECAPTCHA_SITE_KEY = '6LelSEsjAAAAAPUwq6A56Yp9WXtviNMYvmBoMKOZ'
